import { createIcon } from '@chakra-ui/icons';

export const CloseIcon = createIcon({
  displayName: 'CloseIcon',
  viewBox: '0 0 18 18',
  d: 'M0.82768 14.8117C0.24396 15.3996 0.245085 16.3516 0.830193 16.938C1.4153 17.5245 2.36282 17.5234 2.94654 16.9355L8.9977 10.8416L15.0551 16.9274C15.6395 17.5146 16.587 17.5146 17.1715 16.9274C17.7559 16.3403 17.7559 15.3883 17.1715 14.8011L11.1116 8.71281L16.826 2.95797C17.4097 2.37013 17.4086 1.41816 16.8235 0.831695C16.2384 0.24523 15.2909 0.246351 14.7071 0.834195L8.99519 6.58652L3.27557 0.840072C2.69115 0.252916 1.74363 0.252917 1.15922 0.840072C0.574802 1.42723 0.574802 2.37919 1.15922 2.96635L6.88134 8.71531L0.82768 14.8117Z',
});
